import { render, staticRenderFns } from "./ClientSystemChip.vue?vue&type=template&id=31016d48&scoped=true"
import script from "./ClientSystemChip.vue?vue&type=script&lang=js"
export * from "./ClientSystemChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31016d48",
  null
  
)

export default component.exports